import { Select } from "@/components/ui/Select";

export interface FilterOption {
  label: string;
  value: string;
}

/** Single-select filter dropdown used above list/table pages (status, zone, period, …). */
export function Filter({
  label,
  value,
  options,
  onChange,
  allLabel = "All",
}: {
  label?: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
  allLabel?: string;
}) {
  return (
    <label className="flex items-center gap-2 text-sm text-ink-muted">
      {label && <span className="whitespace-nowrap">{label}</span>}
      <Select value={value} onChange={(e) => onChange(e.target.value)} className="w-40">
        <option value="">{allLabel}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </label>
  );
}
